<template>
  <div class="shop-cart">
    <div class="page-title">购物车</div>
    <template v-if="!list.length">
      <div class="empty-cart">
        <div class="empty-icon"></div>
        <div class="empty-tips">您的购物车空空如也,去设计师商城逛逛吧~</div>
        <div class="go-mall-index" @click="$router.push({ name: 'Mall' })">
          去逛逛
        </div>
      </div>
    </template>
    <template v-else>
      <div class="cart-body">
        <div class="cart-list">
          <div class="list-top">
            <div class="top-left">
              <Checkbox
                :value="check_all_total || total_checked"
                @click.prevent.native="handleCheckAll"
                >全选</Checkbox
              >
              <div class="btn-box">
                <!-- <div class="btn-item">移入收藏</div> -->
                <div class="btn-item" @click="onCartDelete('', 'batch')">
                  删除
                </div>
              </div>
            </div>
            <!-- <div class="top-right">
                            <div class="top-right-wrapper">
                                <input type="text" placeholder="搜索购物车内商品"/>
                                <Icon type="ios-search" size="22" />
                            </div>
                        </div> -->
          </div>
          <div class="list-body">
            <div class="list-item" v-for="(item, index) in list" :key="index">
              <div class="item-top">
                <Checkbox
                  :value="
                    item.checked || (item.cart_list.filter((i) => i.is_available != 0).length > 0 && item.cart_list.filter((i) => i.is_available != 0).every((i) => i.checked))
                  "
                  @click.prevent.native="handleCheckAllListItem(item, index)"
                >
                  {{ item.shop_name }}
                </Checkbox>
                <img
                  src="@/assets/images/icon-mall-cart-service.png"
                  @click="showChat(item.designer)"
                  alt=""
                  class="service-icon"
                />
              </div>
              <div
                class="item-body"
                v-for="(cart, cart_index) in item.cart_list"
                :key="cart_index"
              >
                <table>
                  <tbody>
                    <tr>
                      <th class="column-selection">
                        <Checkbox
                          :value="cart.checked"
                          :disabled="cart.is_available == 0"
                          @click.prevent.native="
                            cart.is_available != 0 && onSelectCartItem(index, cart_index)
                          "
                        ></Checkbox>
                      </th>
                      <th style="width: 40%">
                        <div class="info-column">
                            <div class="cover" @click="onCartProductClick(cart)" style="cursor:pointer">
                                <img :src="cart.spec_image|default_img" alt="" />
                                <div v-if="cart.is_available == 0" class="un-sale-tag">商品已下架</div>
                            </div>
                          <!-- <img
                            :src="cart.spec_image | default_img"
                            alt=""
                            class="cover"
                          /> -->
                          <div class="text-box">
                            <div class="product-name-row" :class="{'un-sale':cart.is_available == 0}" @click="onCartProductClick(cart)" style="cursor:pointer">
                              <span v-if="cart.sale_mode == 1 || cart.spec_sale_mode == 1" class="cart-presale-tag">预售</span>
                              <span class="product-name">{{ cart.product_name }}</span>
                            </div>
                            <div class="product-spec">
                              <span :style="{color:`${cart.is_available == 0 ? '#b3b3b3':''}`}"
                                @click="cart.is_available != 0 && onShowSpecBox(cart, index, cart_index)"
                                >{{ cart.spec_info }}
                                <Icon type="ios-arrow-down" size="12"
                              /></span>
                              <div class="spec-box" v-if="cart.show_spec">
                                <div class="spec-wrapper">
                                  <div class="label">颜色</div>
                                  <div class="value-box">
                                    <div
                                      v-for="(
                                        color, color_index
                                      ) in curr_color_list"
                                      :key="color_index"
                                      @click.stop="
                                        onSpecSelect(
                                          'color',
                                          color.uuid,
                                          index,
                                          cart_index,
                                          color.stock,
                                          color.sale_mode,
                                        )
                                      "
                                      :class="[
                                        'value-item',
                                        {
                                          active:
                                            temp_color_uuid == color.uuid &&
                                            (color.stock > 0 ||
                                              isNaN(color.stock) ||
                                              color.sale_mode == 1),
                                          'stock-empty': color.stock < 1 && color.sale_mode != 1,
                                        },
                                      ]"
                                    >
                                      {{ color.name }}
                                      <div
                                        v-if="color.sale_mode == 1"
                                        class="no-stock presale-tag"
                                      >
                                        预售
                                      </div>
                                      <div
                                        v-if="color.stock < 1 && color.sale_mode != 1"
                                        class="no-stock"
                                      >
                                        无货
                                      </div>
                                    </div>
                                  </div>
                                  <div class="label">尺码</div>
                                  <div class="value-box">
                                    <div
                                      v-for="(
                                        size, size_index
                                      ) in curr_size_list"
                                      :key="size_index"
                                      @click.stop="
                                        onSpecSelect(
                                          'size',
                                          size.uuid,
                                          index,
                                          cart_index,
                                          size.stock,
                                          size.sale_mode,
                                        )
                                      "
                                      :class="[
                                        'value-item',
                                        {
                                          active:
                                            temp_size_uuid == size.uuid &&
                                            (size.stock > 0 ||
                                              isNaN(size.stock) ||
                                              size.sale_mode == 1),
                                          'stock-empty': size.stock < 1 && size.sale_mode != 1,
                                        },
                                      ]"
                                    >
                                      {{ size.name }}
                                      <div
                                        v-if="size.sale_mode == 1"
                                        class="no-stock presale-tag"
                                      >
                                        预售
                                      </div>
                                      <div
                                        v-if="size.stock < 1 && size.sale_mode != 1"
                                        class="no-stock"
                                      >
                                        无货
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="btn-box">
                                  <div
                                    class="btn-item"
                                    @click.stop="cart.show_spec = false"
                                  >
                                    取消
                                  </div>
                                  <div
                                    class="btn-item"
                                    @click.stop="
                                      onConfirmSpec(index, cart_index)
                                    "
                                  >
                                    确定
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="un-sale-tips" v-if="cart.is_available == 0">
                                <span>宝贝已不能购买</span>
                                <div class="find-btn" @click.stop="onFindSimilar(cart.product_name)">找相似 <Icon type="ios-arrow-forward" size="14px" /></div>
                            </div>
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="price-column">
                          <div class="sale-price">¥{{ cart.price }}</div>
                          <div class="tag-price">
                            吊牌价¥{{ cart.tag_price }}
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="num-column">
                          <div
                            :class="[
                              'minus-btn',
                              { 'can-not': !cart.num || cart.num < 2 },
                            ]"
                            @click="
                              onCartNumChange('minus', cart, index, cart_index)
                            "
                          >
                            -
                          </div>
                          <input
                            :value="cart.num"
                            type="text"
                            class="num-input"
                            @input="onCartNumInput(cart, index, cart_index, $event)"
                          />
                          <div
                            class="plus-btn"
                            @click="
                              onCartNumChange('plus', cart, index, cart_index)
                            "
                          >
                            +
                          </div>
                        </div>
                      </th>
                      <th>
                        <div class="operation-column">
                          <!-- <div class="operation-item">移入收藏</div> -->
                          <div
                            class="operation-item"
                            @click.stop="onCartDelete(cart.uuid, 'single')"
                          >
                            删除
                          </div>
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="recommend-list">
            <div class="recommend-title">猜你喜欢</div>
            <div class="recommend-list-body">
              <!-- <div class="goods-item"> -->
              <div
                class="goods-item"
                v-for="(item, index) in product_list"
                :key="`guess-like-${index}`"
                @click.stop="onDetailClick(item)"
              >
                <div class="goods-cover">
                  <img :src="item.image | default_img(false)" alt="" class="" />
                  <div
                    class="collect-btn"
                    @click.stop="onCollectProductForList(item.uuid, index)"
                  >
                    <img
                      :src="
                        item.is_collected
                          ? require('@/assets/images/icon-mall-collected.png')
                          : require('@/assets/images/icon-mall-collect.png')
                      "
                      alt=""
                      class="collect-icon"
                    />
                    收藏
                  </div>
                </div>
                <div class="goods-title">{{ item.name }}</div>
                <div class="goods-price">¥{{ item.sale_price }}</div>
                <div class="goods-author">
                  <img
                    :src="item.member.avatar | default_img"
                    alt=""
                    class="avatar"
                  />
                  <div class="nickname">
                    {{ item.member.nickname || "匿名" }}
                  </div>
                  <div class="line">|</div>
                  <div class="count-num">
                    作品:{{ item.member.works || "0" }}
                  </div>
                </div>
              </div>
              <!-- </div> -->
            </div>
          </div>
        </div>
        <div class="cart-total">
          <div class="total-box">
            <div class="total-title">
              结算明细
              <span v-if="selected_list.length"
                >已选商品{{ selected_list.length }}件</span
              >
            </div>
            <div v-if="!selected_list.length" class="total-empty">
              <div class="total-empty-icon"></div>
              <div class="total-empty-text">选择商品查看实际支付价格</div>
            </div>
            <template v-else>
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(item, index) in selected_list"
                  :key="index"
                >
                  <img :src="item.spec_image | default_img" alt="" />
                </div>
              </div>
              <div class="cash-detail-list">
                <div class="list-item">
                  <div class="item-label">商品总额</div>
                  <div class="item-value">¥{{ total_price }}</div>
                </div>
              </div>
            </template>
            <div class="total-price">
              <div class="label">合计:</div>
              <div class="value">¥{{ total_price }}</div>
            </div>
            <div @click="onCashOrder" class="submit-btn">
              结算<span v-if="selected_list.length"
                >({{ selected_list.length || 0 }})</span
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <Chat ref="chat"></Chat>
  </div>
</template>
<script>
import {
  cartChange,
  cartDelete,
  cartSpecChange,
  getCartList,
  getMallProductList,
  productCollect,
  productSpecList,
  productSpecStock,
} from "@/api/index";
export default {
  data() {
    return {
      check_all_total: false,
      indeterminate_total: false,
      list: [],
      // selected_list:[],
      product_list: [],
      curr_color_list: [],
      curr_size_list: [],
      temp_color_uuid: "",
      temp_size_uuid: "",
    };
  },
  computed: {
    total_price() {
      //>计算所有被选中项的总价,selected_list只有cart_list
      return this.selected_list
        .reduce((acc, item) => {
          console.log("acc", acc, "item", item);
          return acc + item.price * item.num;
        }, 0)
        .toFixed(2);
    },
    total_checked() {
      //>判断list中所有可选中的项(未下架)包括子项的checked属性是否都为true
      return this.list.every((item) => {
        const selectable_items = item.cart_list.filter((i) => i.is_available != 0);
        return selectable_items.length === 0 || selectable_items.every((i) => i.checked);
      });
    },
    selected_list() {
      //>返回所有被cart_list中被选中的项(排除已下架商品)
      return this.list.reduce((acc, item) => {
        const selected_cart_items = item.cart_list.filter((i) => i.checked && i.is_available != 0);
        if (selected_cart_items.length > 0) {
          selected_cart_items.forEach((i) => {
            acc.push(i);
          });
        }
        return acc;
      }, []);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "mall");
    });
  },
  mounted() {
    Promise.all([this.onGetCartList(), this.onGetMallProductList()]);
  },
  methods: {
    onFindSimilar(product_name) {
      this.$router.push({ name: 'GoodsList', query: { keyword: product_name } });
    },
    onCartProductClick(cart) {
      if (cart.is_available == 0) {
        this.$layer.msg('商品已下架');
        return;
      }
      this.$router.push({ name: 'GoodsDetail', params: { uuid: cart.product_uuid } });
    },
    async onCollectProductForList(uuid, index) {
      try {
        const { code, msg } = await productCollect({ uuid });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.product_list[index].is_collected =
          !this.product_list[index].is_collected;
        this.$layer.msg("操作成功~");
      } catch (e) {
        console.log("err-collect", e);
      }
    },
    showChat(user) {
      console.log(user);
      this.$refs["chat"].showChat(user);
    },
    async onCashOrder() {
      console.log("selected-list", this.selected_list);
      if (!this.selected_list.length) {
        this.$layer.msg("请至少选择一个商品");
        return;
      }
      // 结算前强制把页面数量同步到后端（绕过防抖），避免后端按购物车表旧数量校验起订量/库存
      try {
        await Promise.all(
          this.selected_list.map((item) =>
            cartChange({
              uuid: item.uuid,
              num: Number(item.num),
            })
          )
        );
      } catch (e) {
        console.log("cart-sync-err", e);
        this.$layer.msg((e && e.msg) || "商品数量同步失败，请重试");
        return;
      }
      const uuids = this.selected_list
        .map((item) => {
          return item.uuid;
        })
        .join(",");
      console.log("uuids", uuids);
      this.$router.push({
        name: "MallCheckOut",
        query: { uuid: uuids, from: "cart" },
      });
    },
    async onConfirmSpec(shop_index, cart_index) {
      try {
        const { temp_size_uuid, curr_size_list } = this;
        const { price, stock, sale_mode } = curr_size_list.find((item) => {
          return item.uuid === temp_size_uuid;
        });
        //>规格级预售（sale_mode==1）豁免库存校验，否则预售规格(stock=0)无法确认改规格
        if (sale_mode != 1 && (!stock || stock < 1)) {
          this.$layer.msg("库存不足");
          return;
        }
        this.list[shop_index].cart_list[cart_index].price = price;
        this.list[shop_index].cart_list[cart_index].show_spec = false;
        await cartSpecChange({
          uuid: this.list[shop_index].cart_list[cart_index].uuid,
          size_uuid: this.temp_size_uuid,
          color_uuid: this.temp_color_uuid,
        });
        this.onGetCartList();
      } catch (e) {
        console.log("change-spec-err", e);
        this.$layer.msg(e.msg);
      }
    },
    async onSpecSelect(type, uuid, index, cart_index, stock, sale_mode) {
      //>规格级预售（sale_mode==1）豁免库存校验，否则预售规格(stock=0)无法选入
      if (sale_mode != 1 && (!stock || stock < 1)) {
        this.$layer.msg("库存不足");
        return;
      }
      if (type === "color") {
        const data = await this.getSpecStock(uuid, "2");
        // 检查是否有库存，如果没有则不执行后续操作
        const selectedItem = data.find((size) => {
          return size.attr_uuid === uuid;
        });
        if (selectedItem && selectedItem.stock === 0) {
          this.$layer.msg("该颜色无库存");
          return;
        }
        this.curr_size_list = this.curr_size_list.map((item) => {
          const { stock, price, sale_mode } = data.find((size) => {
            return size.attr_uuid === item.uuid;
          }) || {};
          return {
            ...item,
            stock,
            price,
            sale_mode: sale_mode || 0,
          };
        });
        console.log("size_list", this.curr_size_list);
        this.temp_color_uuid = uuid;
      }
      if (type === "size") {
        const data = await this.getSpecStock(uuid, "1");
        // 检查是否有库存，如果没有则不执行后续操作
        const selectedItem = data.find((color) => {
          return color.attr_uuid === uuid;
        });
        if (selectedItem && selectedItem.stock === 0) {
          this.$layer.msg("该尺寸无库存");
          return;
        }
        this.curr_color_list = this.curr_color_list.map((item) => {
          const { stock, price, sale_mode } = data.find((color) => {
            return color.attr_uuid === item.uuid;
          }) || {};
          return {
            ...item,
            stock,
            price,
            sale_mode: sale_mode || 0,
          };
        });
        console.log("color_list", this.curr_color_list);
        this.temp_size_uuid = uuid;
      }
    },
    async getSpecStock(uuid, type) {
      try {
        const { code, msg, data } = await productSpecStock({ uuid, type });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        return data;
      } catch (e) {
        console.log("err-spec-stock", e);
      }
    },
    async onShowSpecBox({ product_id }, shop_index, cart_index) {
      try {
        const { code, data, msg } = await productSpecList({ product_id });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        const color_uuid = data.color[0].uuid;
        const size_uuid = data.size[0].uuid;
        const color_spec_stock = await this.getSpecStock(size_uuid, "1");
        const size_spec_stock = await this.getSpecStock(color_uuid, "2");
        console.log("size_spec_stock", size_spec_stock);
        console.log("color_spec_stock", color_spec_stock);
        // console.log('data-->spec-list',data);
        this.curr_color_list = data.color.map((item) => {
          const si = color_spec_stock.find((i) => i.attr_uuid === item.uuid) || {};
          return {
            ...item,
            stock: si.stock,
            price: si.price,
            //>规格级预售标记（来自 specStock 新增字段），用于豁免库存校验/缺货展示
            sale_mode: si.sale_mode || 0,
          };
        });
        this.curr_size_list = data.size.map((item) => {
          const si = size_spec_stock.find((i) => i.attr_uuid === item.uuid) || {};
          return {
            ...item,
            stock: si.stock,
            price: si.price,
            sale_mode: si.sale_mode || 0,
          };
        });
        console.log("this.curr_color_list", this.curr_color_list);
        console.log("this.curr_size_list", this.curr_size_list);
        this.list[shop_index].cart_list[cart_index].show_spec = true;
      } catch (e) {
        console.log("err", e);
      }
    },
    async onCartDelete(uuid = "", type = "single") {
      if (type === "single") {
        const { code, msg } = await cartDelete({ uuid });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
      } else {
        const uuids = this.selected_list.map((i) => i.uuid);
        const { code, msg } = await cartDelete({ uuid: uuids.join(",") });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
      }

      this.$layer.msg("删除成功");
      this.onGetCartList();
    },
    handleCheckAllListItem(item, shop_index) {
      console.log("item===>", item);
      const new_checked = !item.checked;
      this.$set(this.list, [shop_index], {
        ...item,
        checked: new_checked,
        cart_list: item.cart_list.map((i) => {
          // 已下架商品保持未选中状态
          if (i.is_available == 0) {
            return {
              ...i,
              checked: false,
            };
          }
          return {
            ...i,
            checked: new_checked,
          };
        }),
      });
    },
    onSelectCartItem(shop_index, cart_index) {
      const cart_item = this.list[shop_index].cart_list[cart_index];
      // 已下架商品不可选中
      if (cart_item.is_available == 0) return;

      cart_item.checked = !cart_item.checked;
      // 判断店铺是否全选(只考虑未下架商品)
      const selectable_items = this.list[shop_index].cart_list.filter((i) => i.is_available != 0);
      if (selectable_items.length > 0 && selectable_items.every((i) => i.checked)) {
        this.list[shop_index].checked = true;
      } else {
        this.list[shop_index].checked = false;
      }
      // 判断全局全选
      if (
        this.list.every((item) => {
          const selectable = item.cart_list.filter((i) => i.is_available != 0);
          return selectable.length === 0 || selectable.every((i) => i.checked);
        })
      ) {
        this.check_all_total = true;
      } else {
        this.check_all_total = false;
      }
    },
    onCartNumInput(cart, index, cart_index, event) {
      // 手动输入数量：直接从 DOM 事件读值（不依赖 v-model 在 v-for 别名上的响应式时序），
      // 显式写回 cart.num，保证模型永远是用户输入的真实值，结算兜底 sync 才不会读到旧值
      const raw = event && event.target ? event.target.value : cart.num;
      let num = parseInt(raw, 10);
      if (isNaN(num) || num < 1) {
        num = 1;
        this.$layer.msg("商品数量不能少于1");
      }
      //>规格级预售（spec_sale_mode==1）不限制数量，否则预售规格(stock=0)无法调整数量
      if (num > cart.stock && cart.spec_sale_mode != 1) {
        num = cart.stock;
        this.$layer.msg("商品库存不足");
      }
      this.list[index].cart_list[cart_index].num = num;
      this.syncCartNum({ uuid: cart.uuid, num });
    },
    onCartNumChange(type, { uuid, num, stock }, index, cart_index) {
      if (type === "minus") {
        if (num <= 1) {
          this.$layer.msg("商品数量不能少于1");
          return;
        }
        num--;
        this.list[index].cart_list[cart_index].num = num;
      }
      if (type === "plus") {
        //>规格级预售（spec_sale_mode==1）不限制数量
        const cartItem = this.list[index].cart_list[cart_index];
        if (num >= stock && cartItem.spec_sale_mode != 1) {
          this.$layer.msg("商品库存不足");
          return;
        }
        num++;
        this.list[index].cart_list[cart_index].num = num;
      }
      const param = {};
      param.uuid = uuid;
      param.num = num;
      console.log("param", param);
      this.syncCartNum(param);
    },
    syncCartNum: _.debounce(async function (param) {
      console.log("param", param, "time", new Date());
      // return;
      try {
        const { code, msg } = await cartChange(param);
        console.log("code", code, "msg", msg);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
      } catch (e) {
        console.log("cart-change-err", e);
        this.$layer.msg(e.msg);
      }
      // this.onGetCartList();
    }, 300),
    async onGetCartList() {
      const { code, data, msg } = await getCartList();
      if (code > 0) {
        this.$layer.msg(msg);
        return;
      }
      this.list = data.map((item) => {
        console.log("item", item);

        return {
          // ...res,
          ...item,
          cart_list: item.cart_list.map((i) => {
            return {
              ...i,
              // 已下架商品强制未选中
              checked: i.is_available == 0 ? false : false,
              show_spec: false,
            };
          }),
          checked: false,
        };
      });
      console.log("list", this.list);
    },
    onDetailClick({ uuid }) {
      this.$router.push({ name: "GoodsDetail", params: { uuid } });
    },
    async onGetMallProductList() {
      const { code, data, msg } = await getMallProductList({
        page: 1,
        size: 15,
      });
      if (code > 0) {
        this.$layer.msg(msg);
        return;
      }
      this.product_list = [];
      this.product_list = data.list;
      this.total = data.count;
    },
    handleCheckAll() {
      this.check_all_total = !this.check_all_total;
      if (this.check_all_total) {
        //>全选：只选中未下架商品
        this.list = this.list.map((item) => {
          return {
            ...item,
            checked: true,
            cart_list: item.cart_list.map((i) => {
              return {
                ...i,
                checked: i.is_available != 0,
              };
            }),
          };
        });
      } else {
        //>取消全选：全部取消
        this.list = this.list.map((item) => {
          return {
            ...item,
            checked: false,
            cart_list: item.cart_list.map((i) => {
              return {
                ...i,
                checked: false,
              };
            }),
          };
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-cart {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 180px;
  padding-bottom: 100px;
  .page-title {
    width: 100%;
    font-size: 26px;
    color: #1f1f1f;
    font-weight: bold;
    margin-top: 34px;
  }
  .empty-cart {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 373px;
    margin-top: 75px;
    .empty-icon {
      width: 100%;
      height: 188px;
      background: url("../../assets/images/empty-shop-cart.png");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    .empty-tips {
      color: #999999;
      font-size: 16px;
      margin-top: 42px;
    }
    .go-mall-index {
      margin-top: 61px;
      width: 280px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      border-radius: 10px;
      background: #fa3d5a;
      color: #ffffff;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
    }
  }
  .cart-body {
    display: flex;
    column-gap: 50px;
    min-height: 100vh;
    .cart-list {
      flex: 1;
      flex-shrink: 0;
      margin-top: 29px;
      .list-top {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #ebebeb;
        .top-left {
          display: flex;
          align-items: center;
          column-gap: 19px;
          .btn-box {
            display: flex;
            align-items: center;
            column-gap: 8px;
            .btn-item {
              height: 32px;
              border-radius: 8px;
              line-height: 32px;
              border: 1px solid #ebebeb;
              padding: 0 13px;
              cursor: pointer;
            }
          }
        }
        .top-right {
          width: 200px;
          height: 32px;
          border: 1px solid #d6d6d6;
          border-radius: 8px;
          overflow: hidden;
          .top-right-wrapper {
            display: flex;
            align-items: center;
            width: 100%;
            height: 100%;
            padding: 0 10px;
            input {
              width: calc(100% - 20px);
              border: none;
              outline: none;
              height: 100%;
            }
            ::v-deep .ivu-icon {
              cursor: pointer;
            }
          }
        }
      }
      .list-body {
        width: 100%;
        display: flex;
        flex-direction: column;
        // row-gap:25px;
        .list-item {
          width: 100%;
          margin-top: 25px;
          padding-bottom: 25px;
          border-bottom: 1px solid #ebebeb;
          display: flex;
          flex-direction: column;
          row-gap: 18px;
          .item-top {
            display: flex;
            align-items: center;
            .service-icon {
              width: 22px;
              height: 22px;
              cursor: pointer;
            }
          }
          .item-body {
            width: 100%;
            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: fixed;
              text-align: center;
              tbody > tr > th {
                &.column-selection {
                  width: 20px;
                }
                .info-column {
                  display: flex;
                  column-gap: 13px;
                  margin-left: 16px;

                  .cover {
                    width: 96px;
                    height: 96px;
                    background: #f5f5f5;
                    border-radius: 8px;
                    overflow:hidden;
                    position: relative;
                    .un-sale-tag{
                        position:absolute;
                        bottom:0;
                        left:0;
                        width:100%;
                        background:rgba(0,0,0,0.5);
                        text-align:center;
                        padding:2px 0;
                        color:#fff;
                        font-size:14px;
                    }
                    img{
                        width:100%;
                        height:100%;
                        object-fit: cover;
                    }
                  }
                  .text-box {
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    .product-name-row {
                      display: flex;
                      align-items: flex-start;
                      &.un-sale .product-name {
                        color: #b3b3b3;
                      }
                      .cart-presale-tag {
                        flex-shrink: 0;
                        margin: 1px 6px 0 0;
                        padding: 0 5px;
                        height: 18px;
                        line-height: 18px;
                        font-size: 12px;
                        color: #ffffff;
                        background: #ff0f23;
                        border-radius: 3px;
                      }
                      .product-name {
                        flex: 1;
                        min-width: 0;
                        color: #333333;
                        font-size: 14px;
                        font-weight: 500;
                        line-clamp:2;
                        -webkit-line-clamp: 2;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }
                    }
                    .product-spec {
                      display: flex;
                      align-items: center;
                      color: #666666;
                      font-size: 14px;
                      cursor: pointer;
                      position: relative;
                      .spec-box {
                        position: absolute;
                        left: 0;
                        bottom: -1550%;
                        width: 500px;
                        min-height: 320px;
                        box-shadow: 0px 0px 16px 0px #d4d4d4;
                        background: #ffffff;
                        border-radius: 10px;
                        z-index: 10;
                        // position:relative;
                        .spec-wrapper {
                          padding: 20px;
                          display: flex;
                          flex-direction: column;
                          align-items: start;
                          .label {
                            color: #333333;
                            font-size: 14px;
                          }
                          .value-box {
                            display: flex;
                            column-gap: 10px;
                            flex-wrap: wrap;
                            margin-bottom: 20px;
                            margin-top: 10px;
                            .value-item {
                              color: #333333;
                              font-size: 14px;
                              padding: 6px 11px;
                              background: #f7f8fc;
                              border: 1px solid #f2f3f7;
                              border-radius: 3px;
                              cursor: pointer;
                              position: relative;
                              &.active {
                                color: #fa3d5a;
                                border: 1px solid #fa3d5a;
                                background: #ffebf1;
                              }
                              &.stock-empty {
                                color: #999999;
                                cursor: not-allowed;
                              }
                              .no-stock {
                                position: absolute;
                                top: -10px;
                                right: 0;
                                background: #a0a1a3;
                                color: #ffffff;
                                font-size: 12px;
                                padding: 0 5px;
                                white-space: nowrap;
                              }
                              //>规格级预售标记：红色小角标，区别于灰色"无货"
                              .presale-tag {
                                background: #ff0f23;
                              }
                            }
                          }
                        }
                        .btn-box {
                          display: flex;
                          column-gap: 8px;
                          position: absolute;
                          bottom: 20px;
                          right: 20px;
                          .btn-item {
                            color: #333333;
                            font-size: 14px;
                            padding: 9px 30px;
                            background: #ffffff;
                            border: 1px solid #d6d6d6;
                            border-radius: 3px;
                            cursor: pointer;
                            &:last-child {
                              color: #ffffff;
                              background: #fa3d5a;
                              border: none;
                            }
                          }
                        }
                      }
                    }
                    .un-sale-tips{
                        display:flex;
                        align-items:center;
                        margin-top:8px;
                        column-gap:24px;
                        user-select:none;
                        span:first-child{
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .find-btn{
                            font-weight: 400;
                            font-size: 14px;
                            color: #FF5967;
                            display:flex;
                            align-items:center;
                            cursor:pointer;
                        }
                    }
                  }
                }
                .price-column {
                  display: flex;
                  flex-direction: column;
                  align-items: start;
                  // justify-content:start;
                  height: 96px;
                  .sale-price {
                    color: #fa3d5a;
                    font-size: 16px;
                    font-weight: bold;
                  }
                  .tag-price {
                    color: #999999;
                    font-size: 13px;
                  }
                }
                .num-column {
                  display: flex;
                  align-items: center;
                  width: 104px;
                  overflow: hidden;
                  height: 32px;
                  border: 1px solid #d6d6d6;
                  border-radius: 1px;
                  .minus-btn,
                  .plus-btn {
                    width: 32px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 20px;
                    color: #333333;
                    cursor: pointer;
                    user-select: none;
                    flex-shrink: 0;
                    &.can-not {
                      color: #b7bac0;
                      cursor: not-allowed;
                    }
                  }
                  .num-input {
                    width: calc(100% - 64px);
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    font-size: 16px;
                    color: #333333;
                    border: none;
                    outline: none;
                    border-left: 1px solid #d6d6d6;
                    border-right: 1px solid #d6d6d6;
                  }
                }
                .operation-column {
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  .operation-item {
                    cursor: pointer;
                    color: #808080;
                    font-size: 14px;
                    font-weight: 400;
                  }
                }
              }
            }
          }
        }
      }
      .recommend-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 40px;
        .recommend-title {
          color: #1f1f1f;
          font-size: 20px;
          font-weight: bold;
        }
        .recommend-list-body {
          width: 100%;
          margin-top: 30px;
          display: flex;
          flex-wrap: wrap;
          column-gap: 18px;
          row-gap: 30px;
          .goods-item {
            width: calc(100% / 4 - 18px);
            background: #ffffff;
            display: flex;
            flex-direction: column;
            align-items: stretch;

            .goods-cover {
              width: 100%;
              height: 430px;
              // height:auto;
              min-height: 0;
              // aspect-ratio:1;
              // max-height: 430px;
              border-radius: 6px;
              background: #f5f5f5;
              overflow: hidden;
              position: relative;
              // aspect-ratio:1;
              display: flex;

              img {
                width: 100%;
                // height: 100%;
                height: auto;
                display: block;
                // min-height:330px;
                // max-height:430px;
                border-radius: 6px;
                object-fit: contain;
              }

              .collect-btn {
                display: none;
              }

              &:hover {
                .collect-btn {
                  position: absolute;
                  right: 20px;
                  bottom: 20px;
                  background: rgba(255, 255, 255, 0.7);
                  border-radius: 16px;
                  color: #4d4d4d;
                  font-size: 12px;
                  display: flex;
                  align-items: center;
                  column-gap: 4px;
                  padding: 6px 10px;
                  cursor: pointer;
                  max-height: 32px;

                  .collect-icon {
                    width: 20px;
                    height: 20px;
                    max-height: 20px;
                    min-height: 20px;
                  }
                }
              }
            }

            .goods-title {
              // margin-top:20px;
              line-height: 35.81px;
              color: #1a1a1a;
              font-size: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .goods-price {
              line-height: 35.81px;
              color: #1a1a1a;
              font-size: 18px;
              font-weight: bold;
            }

            .goods-author {
              display: flex;
              align-items: center;
              width: 100%;
              .avatar {
                width: 25px;
                height: 25px;
                border-radius: 50%;
                margin-right: 9px;
              }

              .line {
                margin: 0 9px;
                font-size: 13px;
              }

              .nickname,
              .count-num {
                flex: 0 0 1;
                color: #666666;
                font-size: 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
    .cart-total {
      width: 380px;
      max-height: 400px;
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 10px;
      position: sticky;
      top: 15%;
      .total-box {
        padding: 20px;
        display: flex;
        flex-direction: column;
        .total-title {
          color: #1f1f1f;
          font-size: 18px;
          font-weight: bold;
          span {
            color: #575859;
            font-size: 12px;
            margin-left: 12px;
          }
        }
        .total-empty {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          row-gap: 28px;
          margin-top: 50px;
          margin-bottom: 45px;
          .total-empty-icon {
            width: 205px;
            height: 104px;
            background: url("../../assets/images/empty-shop-cart.png");
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
          }
          .total-empty-text {
            color: #fa3d5a;
            font-size: 14px;
          }
        }
        .selected-box {
          width: 100%;
          display: flex;
          flex-wrap: nowrap;
          gap: 8px;
          margin-top: 22px;
          overflow: hidden;
          .selected-item {
            width: 74px;
            height: 74px;
            background: #f5f5f5;
            border-radius: 5px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }
        .cash-detail-list {
          width: 100%;
          padding: 20px 0;
          border-bottom: 1px solid #ebebeb;
          margin-bottom: 30px;
          .list-item {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .item-label {
              color: #575859;
              font-size: 14px;
            }
            .item-value {
              color: #333333;
              font-size: 14px;
              font-weight: bold;
            }
          }
        }
        .total-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          .label {
            color: #575859;
            font-size: 16px;
            font-weight: bold;
          }
          .value {
            color: #fa3d5a;
            font-size: 18px;
            font-weight: bold;
          }
        }
        .submit-btn {
          width: 100%;
          height: 42px;
          line-height: 42px;
          text-align: center;
          color: #ffffff;
          background: #fa3d5a;
          border-radius: 10px;
          cursor: pointer;
          font-weight: 500;
        }
      }
    }
  }
}

@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .shop-cart {
    padding: 0 80px;
    padding-bottom: 100px;

    .cart-body {
      column-gap: 30px;

      .cart-list {
        .list-top {
          .top-right {
            width: 160px;
          }
        }

        .list-body {
          .list-item {
            .item-body {
              table {
                tbody > tr > th {
                  .info-column {
                    column-gap: 10px;

                    .cover {
                      width: 80px;
                      height: 80px;
                    }

                    .text-box {
                      .product-name {
                        font-size: 13px;
                      }

                      .product-spec {
                        font-size: 13px;

                        .spec-box {
                          width: 400px;
                          min-height: 280px;
                        }
                      }
                    }
                  }

                  .price-column {
                    .sale-price {
                      font-size: 15px;
                    }

                    .tag-price {
                      font-size: 12px;
                    }
                  }

                  .num-column {
                    width: 90px;
                    height: 28px;

                    .minus-btn,
                    .plus-btn {
                      width: 28px;
                      height: 28px;
                      line-height: 28px;
                      font-size: 18px;
                    }

                    .num-input {
                      width: calc(100% - 56px);
                      height: 28px;
                      line-height: 28px;
                      font-size: 15px;
                    }
                  }
                }
              }
            }
          }
        }

        .recommend-list {
          .recommend-list-body {
            column-gap: 15px;
            row-gap: 25px;

            .goods-item {
              width: calc(100% / 4 - 15px);

              .goods-cover {
                height: 360px;
              }
            }
          }
        }
      }

      .cart-total {
        width: 320px;
        max-height: 380px;

        .total-box {
          padding: 15px;

          .total-title {
            font-size: 16px;
          }

          .selected-box {
            .selected-item {
              width: 60px;
              height: 60px;
            }
          }

          .cash-detail-list {
            padding: 15px 0;
            margin-bottom: 25px;

            .list-item {
              .item-label {
                font-size: 13px;
              }

              .item-value {
                font-size: 13px;
              }
            }
          }

          .total-price {
            margin-bottom: 15px;

            .label {
              font-size: 15px;
            }

            .value {
              font-size: 17px;
            }
          }

          .submit-btn {
            height: 38px;
            line-height: 38px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1279px) {
  .shop-cart {
    padding: 0 100px;
    padding-bottom: 60px;
  }

  .shop-cart .page-title {
    font-size: 20px;
    margin-top: 25px;
  }

  .shop-cart .empty-cart {
    width: 300px;
    margin-top: 50px;
  }

  .shop-cart .empty-cart .empty-icon {
    height: 150px;
  }

  .shop-cart .empty-cart .empty-tips {
    font-size: 14px;
    margin-top: 30px;
  }

  .shop-cart .empty-cart .go-mall-index {
    margin-top: 40px;
    width: 220px;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
  }

  .shop-cart .cart-body {
    column-gap: 30px;
    min-height: auto;
  }

  .shop-cart .cart-body .cart-list {
    margin-top: 20px;
  }

  .shop-cart .cart-body .cart-list .list-top {
    padding-bottom: 15px;
  }

  .shop-cart .cart-body .cart-list .list-top .top-left {
    column-gap: 15px;
  }

  .shop-cart .cart-body .cart-list .list-top .top-left .btn-box {
    column-gap: 6px;
  }

  .shop-cart .cart-body .cart-list .list-top .top-left .btn-box .btn-item {
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    font-size: 13px;
  }

  .shop-cart .cart-body .cart-list .list-top .top-right {
    width: 160px;
    height: 28px;
  }

  .shop-cart .cart-body .cart-list .list-body .list-item {
    margin-top: 20px;
    padding-bottom: 20px;
    row-gap: 15px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-top
    .service-icon {
    width: 20px;
    height: 20px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th.column-selection {
    width: 18px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column {
    column-gap: 10px;
    margin-left: 12px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .cover {
    width: 80px;
    height: 80px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-name {
    font-size: 13px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec {
    font-size: 13px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box {
    width: 400px;
    min-height: 280px;
    bottom: -1300%;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .spec-wrapper {
    padding: 16px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .spec-wrapper
    .label {
    font-size: 13px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .spec-wrapper
    .value-box {
    column-gap: 8px;
    margin-bottom: 16px;
    margin-top: 8px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .spec-wrapper
    .value-box
    .value-item {
    font-size: 13px;
    padding: 5px 9px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .btn-box {
    column-gap: 6px;
    bottom: 16px;
    right: 16px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .info-column
    .text-box
    .product-spec
    .spec-box
    .btn-box
    .btn-item {
    font-size: 13px;
    padding: 7px 24px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .price-column {
    height: 80px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .price-column
    .sale-price {
    font-size: 14px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .price-column
    .tag-price {
    font-size: 12px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .num-column {
    width: 90px;
    height: 28px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .num-column
    .minus-btn,
  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .num-column
    .plus-btn {
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 18px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .num-column
    .num-input {
    width: calc(100% - 56px);
    height: 28px;
    line-height: 28px;
    font-size: 14px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .list-body
    .list-item
    .item-body
    table
    tbody
    > tr
    > th
    .operation-column
    .operation-item {
    font-size: 13px;
  }

  .shop-cart .cart-body .cart-list .recommend-list {
    margin-top: 30px;
  }

  .shop-cart .cart-body .cart-list .recommend-list .recommend-title {
    font-size: 18px;
  }

  .shop-cart .cart-body .cart-list .recommend-list .recommend-list-body {
    margin-top: 20px;
    column-gap: 15px;
    row-gap: 25px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item {
    width: calc(100% / 4 - 15px);
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-cover {
    height: 350px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-title {
    font-size: 14px;
    line-height: 28px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-price {
    font-size: 16px;
    line-height: 28px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-author
    .avatar {
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-author
    .line {
    margin: 0 8px;
    font-size: 12px;
  }

  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-author
    .nickname,
  .shop-cart
    .cart-body
    .cart-list
    .recommend-list
    .recommend-list-body
    .goods-item
    .goods-author
    .count-num {
    font-size: 12px;
  }

  .shop-cart .cart-body .cart-total {
    width: 320px;
    max-height: 380px;
  }

  .shop-cart .cart-body .cart-total .total-box {
    padding: 16px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-title {
    font-size: 16px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-title span {
    font-size: 11px;
    margin-left: 10px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-empty {
    margin-top: 40px;
    margin-bottom: 35px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-empty .total-empty-icon {
    width: 180px;
    height: 90px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-empty .total-empty-text {
    font-size: 13px;
  }

  .shop-cart .cart-body .cart-total .total-box .selected-box {
    margin-top: 18px;
  }

  .shop-cart .cart-body .cart-total .total-box .selected-box .selected-item {
    width: 65px;
    height: 65px;
  }

  .shop-cart .cart-body .cart-total .total-box .cash-detail-list {
    padding: 16px 0;
    margin-bottom: 25px;
  }

  .shop-cart .cart-body .cart-total .total-box .cash-detail-list .list-item {
    margin-bottom: 2px;
  }

  .shop-cart
    .cart-body
    .cart-total
    .total-box
    .cash-detail-list
    .list-item
    .item-label {
    font-size: 13px;
  }

  .shop-cart
    .cart-body
    .cart-total
    .total-box
    .cash-detail-list
    .list-item
    .item-value {
    font-size: 13px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-price {
    margin-bottom: 16px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-price .label {
    font-size: 15px;
  }

  .shop-cart .cart-body .cart-total .total-box .total-price .value {
    font-size: 16px;
  }

  .shop-cart .cart-body .cart-total .total-box .submit-btn {
    height: 38px;
    line-height: 38px;
    font-size: 14px;
  }
}
</style>
